export function joinAreaNames(names: (string | null | undefined)[]): string {
  return names.filter(Boolean).join(', ');
}
